import { Close } from "@carbon/icons-react";
import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  Popover,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import { SidebarItemsType } from "../../../models/sidebar";
import "./MobileNavBarPopup.scss";

interface MobileNavBarPopupProps {
  isOpen: boolean;
  handleClose: () => void;
  item?: SidebarItemsType;
}

export default function MobileNavBarPopup(props: MobileNavBarPopupProps) {
  const { isOpen, handleClose, item } = props;
  const navigate = useNavigate();

  const clickItem = (item: SidebarItemsType) => {
    navigate(item.href);
    handleClose();
  };

  return (
    <>
      <Popover
        id="mobile-nav-bar-popup-arrow"
        anchorEl={
          item
            ? document.getElementById("mobile-nav-bar-item-" + item.title)
            : null
        }
        open={isOpen}
        onClose={handleClose}
        transformOrigin={{ horizontal: "center", vertical: "bottom" }}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <div className="mobile-nav-bar-popup-arrow-item" />
      </Popover>
      <Menu
        id="mobile-nav-bar-popup"
        anchorEl={
          item
            ? document.getElementById("mobile-nav-bar-item-" + item.title)
            : null
        }
        open={isOpen}
        onClose={handleClose}
        PaperProps={{ className: "mobile-nav-bar-popup" }}
        transformOrigin={{ horizontal: "center", vertical: "bottom" }}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
      >
        <div
          data-testid="mobile-nav-bar-popup"
          className="mobile-nav-bar-popup-header"
        >
          <Close onClick={handleClose} size={32} />
        </div>
        <MenuList>
          {item &&
            item.children &&
            item.children.map((item) => {
              return (
                <MenuItem
                  className={"mobile-nav-bar-popup-item"}
                  onClick={() => clickItem(item)}
                  key={item.title}
                  data-testid={"mobile-nav-bar-popup-item-" + item.title}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText>{item.title}</ListItemText>
                </MenuItem>
              );
            })}
        </MenuList>
      </Menu>
    </>
  );
}
